module.exports = __webpack_public_path__ + "static/media/4980.97680ddb.jpg";